import { UserRole } from '@gql'
import { defineMessages, type IntlShape } from 'react-intl'

export const userRoleMessages = defineMessages({
  admin: {
    defaultMessage: 'Admin',
    description: 'user role title',
  },
  manager: {
    defaultMessage: 'Manager',
    description: 'user role title',
  },
  mediator: {
    defaultMessage: 'Mediator',
    description: 'user role title',
  },
  negotiator: {
    defaultMessage: 'Negotiator',
    description: 'user role title',
  },
  operator: {
    defaultMessage: 'Operator',
    description: 'user role title',
  },
  operatorInactive: {
    defaultMessage: 'Operator Inactive',
    description: 'user role title',
  },
  other: {
    defaultMessage: 'Other',
    description: 'user role title',
  },
  teamLeader: {
    defaultMessage: 'Team Leader',
    description: 'user role title',
  },
})

export function translateUserRole(intl: IntlShape, type: UserRole): string {
  switch (type) {
    case UserRole.ADMIN:
      return intl.formatMessage(userRoleMessages.admin)
    case UserRole.MANAGER:
      return intl.formatMessage(userRoleMessages.manager)
    case UserRole.MEDITATOR:
      return intl.formatMessage(userRoleMessages.mediator)
    case UserRole.NEGOTIATOR:
      return intl.formatMessage(userRoleMessages.negotiator)
    case UserRole.TEAMLEADER:
      return intl.formatMessage(userRoleMessages.teamLeader)
    case UserRole.OPERATOR:
      return intl.formatMessage(userRoleMessages.operator)
    case UserRole.OPERATOR_INACTIVE:
      return intl.formatMessage(userRoleMessages.operatorInactive)
    case UserRole.OTHER:
      return intl.formatMessage(userRoleMessages.other)
  }
}
